import { facebookWhite, instagramWhite2, twitterWhite } from "assets";
import Logo from "components/global/Logo";
import { Container } from "components/global/Nav";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.footer`
  @media (max-width: 768px) {
    background-color: var(--background);
  }
  .footer-navs {
    margin: 9.6rem 0 0;
    padding-bottom: 9.6rem;
    color: var(--grey_1);
    @media (max-width: 768px) {
      margin-top: 0;
      padding-top: 4.8rem;
      padding-bottom: 4.8rem;
    }
    .top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.4rem;
      border-bottom: 1px solid #e2e2ea;
      padding-bottom: 5.6rem;
      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
    }
    .heading {
      font-size: 2.4rem;
      line-height: 3.2rem;
      margin-bottom: 3.2rem;
      @media (max-width: 768px) {
        margin-bottom: 2.4rem;
        margin-top: 4.8rem;
      }
    }
    & > span {
      margin-left: 2.4rem;
      font-size: 1.4rem;
    }
    .links {
      a {
        font-size: 1.8rem;
        display: block;
        border-bottom: 1px solid var(--grey_1);
        width: fit-content;
        margin-bottom: 2.4rem;
        @media (max-width: 768px) {
          font-weight: 450;
          font-size: 16px;
          line-height: 20px;
          display: block;
          margin-left: 0;
          text-align: center;
          :last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .email {
      font-size: 1.8rem;
      line-height: 2.4rem;
      @media (max-width: 768px) {
        font-weight: 450;
        font-size: 16px;
      }
      
    }

    .social {
      display: flex;
      a {
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4.8rem;
        width: 4.8rem;
        border-radius: 50%;
      }
      & > a + a {
        margin-left: 2.7rem;
      }
    }
  }

  .bottom {
    display: flex;
    font-size: 1.8rem;
    line-height: 2.4rem;

    @media (max-width: 768px) {
      flex-direction: column-reverse;
      p{
        font-weight: 450;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
`;

const Footer = () => {
  return (
    <Wrapper className="outer-most-container">
      <Container>
        <div className="footer-navs">
          <div className="top">
            <div className="logoNText ">
              <h6 className="heading">
                Automating social <br /> media management.
              </h6>
              <Link to="/home">
                <Logo />
              </Link>
            </div>
            <div className="company">
              <h6 className="heading">Company</h6>
              <div className="links">
                <a href="http://blog.postpaddy.com/">Blog</a>
                <a href="http://blog.postpaddy.com/resources/">Resources</a>
                <Link to="/faqs">FAQs</Link>
                <Link to="/pricing">Pricing</Link>
              </div>
            </div>
            <div className="legal">
              <h6 className="heading">Legal</h6>
              <div className="links">
                <Link to="/legal/privacy-policy">Privacy Policy</Link>
                <Link to="/legal/terms">Terms of service</Link>
              </div>
            </div>
            <div>
              <h6 className="heading">Socials</h6>
              <div className="social">
                <a href="https://www.facebook.com/profile.php?id=100054713232702">
                  <img src={facebookWhite} alt="facebook" />
                </a>
                <a href="https://mobile.twitter.com/postpaddy">
                  <img src={twitterWhite} alt="twitteer" />
                </a>
                <a href="https://www.instagram.com/post_paddy">
                  <img src={instagramWhite2} alt="instagram" />
                </a>
              </div>
            </div>
            <div>
              <h6 className="heading"> Contact us</h6>
              <a href="mailto:info@postpaddy.com" className="email">
                info@postpaddy.com
              </a>
            </div>
          </div>
          <div className="bottom">
            <p>
              PostPaddy’s services are provided by Digital Figures LLC. ❤️
              PostPaddy Inc. © 2022.
            </p>
          </div>
        </div>
      </Container>
    </Wrapper>
  );
};

export default Footer;
